<template>
  <div class="module-container">
    <div class="container">
      <div class="content-wrapper">
        <div class="title-wrapper">
          <div class="main-title">
            从单打独斗到<span class="highlight">生态领航</span>
          </div>
          <div class="subtitle">
            告别"不具备能力不敢接单"的焦虑。加入易隆创，依托平台身份与全链路交付资源支撑
          </div>
        </div>
        <div class="button-wrapper">
          <div class="start-button" @click="openDashboard">立刻开启</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      navigaion: {
        material: {
          Completed: '/supplier/material/index',
          unCertification: '/supplier-signature/basic-info',
          Pending: '/supplier-signature/submitted',
        },
        scheme: {
          Completed: '/supplier/scheme/index',
          unCertification: '/scheme-signature/basic-info',
          Pending: '/scheme-signature/submitted',
        },
      }
    }
  },
  computed: mapGetters(['isLoggIn']),
  methods: {
    ...mapActions(['setLoginPopup', 'setLoginCallback']),
    openDashboard() {
      if (this.isLoggIn) window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
      else {
        this.setLoginPopup(true);
        /* this.setLoginCallback(() => {
          window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
        }); */
        this.setLoginCallback(user => {
          if (user.supplierCertificationStatus == 'unCertification' && user.schemeCertificationStatus == 'unCertification') {
            window.open(process.env.VUE_APP_URL + '#/dashboard', '_blank');
            return;
          }
          if (user.supplierCertificationStatus == 'Completed') {
            this.$router.push(this.navigaion['material']['Completed']);
            return;
          }
          if (user.schemeCertificationStatus == 'Completed') {
            this.$router.push(this.navigaion['scheme']['Completed']);
            return;
          }
          if (user.supplierCertificationStatus == 'Pending') {
            this.$router.push(this.navigaion['material']['Pending']);
            return;
          }
          if (user.schemeCertificationStatus == 'Pending') {
            this.$router.push(this.navigaion['scheme']['Pending']);
            return;
          }
        });
      }
    },
  }
};
</script>

<style lang="less" scoped>
.module-container {
  height: 359px;
  background-color: #fff;
  background-image: url('@/assets/img/home/Piloting/background.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    max-width: @content-width;
    width: 100%;
    padding: 0 20px;
  }

  .content-wrapper {
    text-align: center;
    margin: 0 auto;

    .title-wrapper {
      margin-bottom: 48px;

      .main-title {
        font-family: @font-bold;
        font-size: 40px;
        color: #333;
        margin-bottom: 16px;

        .highlight {
          color: #FF8201;
        }
      }

      .subtitle {
        font-size: 24px;
        color: #464A53;
        line-height: 1.6;
      }
    }

    .button-wrapper {
      .start-button {
        width: 340px;
        margin: 0 auto;
        background-color: #FF8201;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        line-height: 52px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background-color: #e67600;
        }
      }
    }
  }
}
</style>
